import { kebabCase } from 'lodash-es'
import type { Template } from '~/api/interface'

export const useTemplateState = () => {
  return useState<any>('templateState', () => ({
    list: [],
    active: null,
    changeCallback: null,
    templateSource: '',
    source: '',
    showInImg: false,
  }))
}

export const useTemplateVisible = () => {
  return useState('templateVisible', () => false)
}

export const useMemoizedPath = () => {
  return useState<string | null>('memoizedPath', () => null)
}

export const useTemplateInit = (
  list: Template[],
  item: Template,
  option: {
    templateSource?: TEMPLATE_SOURCE
    source?: SOURCE
  },
  changeCallback?: ([key, value]: [string, any], data: Template) => void
) => {
  const template = useTemplateState()

  template.value.list = list
  template.value.active = item || list?.[0]
  template.value.changeCallback = changeCallback
  template.value.templateSource = option.templateSource || ''
  template.value.source = option?.source
  const open = useTemplateVisible()
  open.value = true
}

export const useTemplateCancel = () => {
  const template = useTemplateState()
  template.value.list = []
  template.value.active = null
  template.value.changeCallback = null
  template.value.source = ''
  const open = useTemplateVisible()
  const memoizedPath = useMemoizedPath()
  if (memoizedPath.value !== null) {
    history.replaceState({}, '', memoizedPath.value)
  }
  open.value = false
}

export const useClassState = () => {
  return useState<any>('classState', () => ({
    list: [],
    active: null,
    changeCallback: null,
    source: '',
  }))
}

// 分享卡片显示状态-为了处理滚动的时候卡片浮层需要消失
export const useShare = () => {
  return useState('shareVisible', () => false)
}
